function FormatDate(d: string): string {
    const date = new Date(d);
    return date.toISOString().split('T')[0];
}

function FormatHours(timestamp: string): string {
    // Parse the timestamp string into a Date object
    const dateObj = new Date(timestamp);

    // Extract the hour and minute parts
    const hour = dateObj.getHours().toString().padStart(2, '0'); // Ensure two digits
    const minute = dateObj.getMinutes().toString().padStart(2, '0'); // Ensure two digits

    // Return the formatted hour and minute
    return `${hour}:${minute}`;
}

export { FormatDate, FormatHours };
